import {
  buildPath,
  buildTemplatePath,
  ListContext,
  ListContextValue,
  Page,
  PageRoute,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import { DataCenterFile, DataCenterFileEditResource } from "generated/openApi";
import "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { dataCenterFileViewPageRoute } from "../DataCenterFileViewPage/DataCenterFileViewPage";
import { DataCenterFilePageBody } from "./DataCenterFilePageBody";
import { DataCenterFilePageHeader } from "./DataCenterFilePageHeader";


const routeName = "dataCenterFileCreate";

export const dataCenterFileCreatePageRoute: PageRoute = {
  handle: "Data Center File",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const DataCenterFileCreatePage = () => {
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const [dataCenterFile, setDataCenterFile] = useState<DataCenterFile>({} as DataCenterFile);
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [dataCenterFile] });
  const [editResource, setEditResource] = useState<DataCenterFileEditResource>({});
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch();

    ApiService.dataCenterFiles.getEditResource().then((response) => {
      setEditResource(response);
    });
  }, []);

  const fetch = () => {
    ApiService.dataCenterFiles.get(0).then((response) => {
      setDataCenterFile(response);
      resetUnsavedChanges([response]);
    });
  };

  return (
    <Page
      isForm
      header={
        <DataCenterFilePageHeader
          handle={dataCenterFileCreatePageRoute.handle}
          dataCenterFile={dataCenterFile}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
        />
      }
    >
      <DataCenterFilePageBody
        dataCenterFile={dataCenterFile}
        setDataCenterFile={setDataCenterFile}
        editResource={editResource}
        validationErrors={validationErrors}
      />
    </Page>
  );
};
